"use client";

import { Shimmer } from "@/components/ai-elements/shimmer";
import { MessageLoadingSquare } from "./MessageLoadingSquare";
import type { ChatStatus } from "ai";
import type { NoxusUIMessage } from "./noxus-message-types";
import type { ChatDisplayOptions } from "./useChatDisplayOptions";

export function ThinkingLine({ label }: { label?: string }) {
  return (
    <div
      className="flex items-center text-sm text-muted-foreground"
      data-testid="thinking-line"
    >
      {label ? (
        <Shimmer as="span" duration={1.6}>
          {label}
        </Shimmer>
      ) : (
        <MessageLoadingSquare />
      )}
    </div>
  );
}

const DEFAULT_LABEL = "Thinking...";

export function thinkingLabel(
  options: Pick<ChatDisplayOptions, "minimalCaretOnly" | "minimalToolMessage">
): string | null {
  if (!options.minimalCaretOnly) return null;
  return options.minimalToolMessage.trim() || DEFAULT_LABEL;
}

// Until the reply has a part the list draws, the turn has nothing on screen:
// the reply message exists from the stream's first chunk, before any content.
export function isTurnUnstarted(
  status: ChatStatus,
  lastMessage: NoxusUIMessage | undefined
): boolean {
  if (status !== "submitted" && status !== "streaming") return false;
  if (lastMessage?.role !== "assistant") return true;
  return lastMessage.parts.every((part) => part.type === "data-compaction");
}
